import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { api, TELEGRAM } from "../lib/api";
import { Hero, Marquee } from "../components/home/Hero";
import { CTA, Journals, SectionHead, Steps, Why } from "../components/home/Sections";
import { LookupSection } from "../components/home/LookupSection";
import { OpportunityCard } from "../components/opportunities/OpportunityCard";
import { Stagger } from "../components/Reveal";

export default function HomePage() {
  const { t, rtl } = useLang();
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  const [opps, setOpps] = useState(null);

  useEffect(() => { api.get("/opportunities").then((r) => setOpps(r.data.filter((o) => o.status === "open").slice(0, 6))).catch(() => setOpps([])); }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <section className="section" id="opportunities" data-testid="opportunities-section">
        <div className="container">
          <SectionHead kicker={t.opps.kicker} title={t.opps.title} sub={t.opps.sub}
            action={<Link to="/opportunities" className="btn btn-outline" data-testid="view-all-opportunities">{t.opps.viewAll}<Arrow size={16} /></Link>} />
          {opps === null ? <div className="page-loader"><span className="loader" /></div>
            : opps.length === 0 ? <div className="empty" data-testid="home-opportunities-empty">{t.opps.empty}<br /><a href={TELEGRAM} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm" style={{ marginTop: 14 }}>Telegram</a></div>
            : <Stagger className="opp-grid">{opps.map((o) => <OpportunityCard opp={o} key={o.id} />)}</Stagger>}
        </div>
      </section>
      <Why />
      <Steps />
      <Journals />
      <LookupSection />
      <CTA />
    </main>
  );
}
